<template>
  <v-expansion-panel
    :id="id"
    :class="[
      'asc-accordion--item',
      first ? 'asc-accordion--item--first' : null,
      last ? 'asc-accordion--item--last' : null,
    ]"
    :readonly="readonly"
    :disabled="disabled"
    @click="handleAccordionItemClick"
    @change="handleAccordionItemChange"
  >
    <v-expansion-panel-header
      class="asc-accordion--item--header"
      :hide-actions="hideActions"
    >
      <slot name="header"></slot>
      <div v-if="hasSupportingTextSlot" class="supportingText">
        <slot name="supportingText"></slot>
      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content class="asc-accordion--item--content">
      <div :class="[scrollbar ? 'asc-accordion--content-container' : '']">
        <slot></slot>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'AscAccordionItem',

  props: {
    id: {
      type: String,
      default: undefined,
    },
    first: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },
    scrollbar: {
      type: Boolean,
      default: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasSupportingTextSlot() {
      return !!this.$slots.supportingText
    },
  },

  methods: {
    handleAccordionItemClick(event) {
      if (this.id) this.$emit('click', event, this.id)
      else this.$emit('click', event)
    },
    handleAccordionItemChange() {
      if (this.$el) {
        const isOpen = !this.$el.classList.contains('asc-acordion--item-open')
        if (isOpen) {
          if (this.id) this.$emit('onOpen', this.id)
          else this.$emit('onOpen')
        } else {
          if (this.id) this.$emit('onClose', this.id)
          else this.$emit('onClose')
        }
        if (this.id) this.$emit('onToggle', isOpen, this.id)
        else this.$emit('onToggle', isOpen)
      }

      if (this.id) this.$emit('change', this.id)
      else this.$emit('change')
    },
  },
}
</script>

<style lang="scss">
.asc-accordion--item {
  &::before {
    box-shadow: none;
  }

  &:not(:first-child)::after {
    border-color: $gray-400 !important;
  }

  &--header {
    padding: 15px 16px;
    height: 18px;
    color: $primary-black;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 18px;
    text-transform: uppercase;
    min-height: 48px !important;

    .v-icon {
      font-size: 20px;
      color: $primary-black !important;
    }

    &:hover {
      color: $accent-500 !important;

      .v-icon {
        color: $accent-500 !important;
      }
    }

    .supportingText {
      color: $gray-1000;
      margin: 0 8px;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
      text-transform: none;
      font-weight: normal;
    }
  }

  &--content {
    font-size: 14px;
    font-weight: medium;
    line-height: 18px;

    .v-expansion-panel-content__wrap {
      padding: 0 16px 16px;
    }

    .asc-accordion--content-container {
      max-height: 420px;
      display: inline-block;
      overflow-y: auto;
      overflow-x: hidden;
      width: 100%;
    }
  }

  &.asc-acordion--item-open {
    margin: 0;
  }
}
</style>
